import { defineNuxtPlugin } from '#app/nuxt'
import { LazyPrimeCalendar, LazyPrimeChips, LazyPrimeDropdown, LazyPrimeInputGroup, LazyPrimeInputGroupAddon, LazyPrimeInputMask, LazyPrimeInputNumber, LazyPrimeInputSwitch, LazyPrimeInputText, LazyPrimeMultiSelect, LazyPrimeButton, LazyPrimeDataView, LazyPrimePaginator, LazyPrimeTimeline, LazyPrimeCard, LazyPrimeConfirmPopup, LazyPrimeDialog, LazyPrimeFileUpload, LazyPrimeBreadcrumb, LazyPrimeMenu, LazyPrimeSteps, LazyPrimeTabMenu, LazyPrimeChart, LazyPrimeToast, LazyPrimeCarousel, LazyPrimeGalleria, LazyPrimeImage, LazyPrimeBadge, LazyPrimeSkeleton, LazyPrimeProgressBar, LazyPrimeProgressSpinner } from '#components'
const lazyGlobalComponents = [
  ["PrimeCalendar", LazyPrimeCalendar],
["PrimeChips", LazyPrimeChips],
["PrimeDropdown", LazyPrimeDropdown],
["PrimeInputGroup", LazyPrimeInputGroup],
["PrimeInputGroupAddon", LazyPrimeInputGroupAddon],
["PrimeInputMask", LazyPrimeInputMask],
["PrimeInputNumber", LazyPrimeInputNumber],
["PrimeInputSwitch", LazyPrimeInputSwitch],
["PrimeInputText", LazyPrimeInputText],
["PrimeMultiSelect", LazyPrimeMultiSelect],
["PrimeButton", LazyPrimeButton],
["PrimeDataView", LazyPrimeDataView],
["PrimePaginator", LazyPrimePaginator],
["PrimeTimeline", LazyPrimeTimeline],
["PrimeCard", LazyPrimeCard],
["PrimeConfirmPopup", LazyPrimeConfirmPopup],
["PrimeDialog", LazyPrimeDialog],
["PrimeFileUpload", LazyPrimeFileUpload],
["PrimeBreadcrumb", LazyPrimeBreadcrumb],
["PrimeMenu", LazyPrimeMenu],
["PrimeSteps", LazyPrimeSteps],
["PrimeTabMenu", LazyPrimeTabMenu],
["PrimeChart", LazyPrimeChart],
["PrimeToast", LazyPrimeToast],
["PrimeCarousel", LazyPrimeCarousel],
["PrimeGalleria", LazyPrimeGalleria],
["PrimeImage", LazyPrimeImage],
["PrimeBadge", LazyPrimeBadge],
["PrimeSkeleton", LazyPrimeSkeleton],
["PrimeProgressBar", LazyPrimeProgressBar],
["PrimeProgressSpinner", LazyPrimeProgressSpinner],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
